import { Component, Input, SimpleChanges } from '@angular/core';
import { EventViewModel } from '../../../models-views/event.view.model';
import { BehaviorSubject, debounceTime, Subject, takeUntil } from 'rxjs';
import { TaskFilter, TaskResponseModel } from '../../../models/task.model';
import { QuickAddService } from '../../../services/quick-add.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-cet-tasks',
  standalone: false,
  templateUrl: './cet-tasks.component.html',
  styleUrl: './cet-tasks.component.scss',
  providers: [DatePipe],
})
export class CetTasksComponent {
  listOfPriority: any = []
  listOfTaskStatus: any = []
  @Input() displayData: 'pending' | 'all' | 'completed';
  @Input() projectId: any = null;
  @Input() eventId: number | null = null;
  taskDataList = new BehaviorSubject<TaskResponseModel>(new TaskResponseModel())
  loading: boolean = false;
  taskList = [];
  destroy$ = new Subject()
  searchText: string
  searchText$: Subject<string> = new Subject<string>()
  showTaskDetail: boolean = false
  selectData: any
  selectedType: any
  usergrouplist: any[] = []
  userlist: any[] = []
  userVisible: boolean = false
  groupVisible: boolean = false
  statusVisible: boolean = false
  priorityVisible: boolean = false
  taskFilter: TaskFilter = {
    id: undefined,
    project_name: undefined,
    assigned_to: undefined,
    assigned_to_group: undefined,
    task_status: undefined,
    priority: undefined,
    due_date: undefined,
    status: undefined,
  }


  constructor(private vm: EventViewModel, private quickAddService: QuickAddService, private datepipe: DatePipe) {
    this.vm.cetTasksComponent = this
    this.vm.taskStatusList.pipe(takeUntil(this.destroy$)).subscribe(data => { this.listOfTaskStatus = data.results });
    this.vm.priorityList.pipe(takeUntil(this.destroy$)).subscribe(data => { this.listOfPriority = data.results });

    this.searchText$.pipe(takeUntil(this.destroy$), debounceTime(500)).subscribe(d => {
      // Only search if event has a project assigned
      if (!this.projectId || !this.projectId.id) {
        return;
      }

      this.loading = true;
      let obj = this.getBasicFilterObject();
      obj['name'] = d;
      this.vm.getTaskList(1, 100, '', obj)
    })

    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.getData();
      }
    })

    this.vm.userGroupList.subscribe(data => {
      this.usergrouplist = data.results
    })

    this.vm.userList.subscribe(data => {
      this.userlist = data.results
    })
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.vm.subscribeToProjectTask(this.taskDataList);
    this.taskDataList.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.projectTaskRecieved();
    });
    this.vm.getUserList(1, 500)
    this.vm.getUserGroupList(1, 100)
  }

  ngOnChanges(changes: SimpleChanges): void {
    // This is called when @Input properties change
    if (changes['projectId']) {
      // Log when projectId data is received from parent
      // console.log('projectId received from parent:', this.projectId);
      // If projectId becomes available and we haven't loaded data yet, load it
      if (this.projectId && this.projectId.id && this.taskList.length === 0) {
        this.getData();
      }
    }
  }

  getBasicFilterObject() {
    let obj = Object.assign({}, this.taskFilter)

    if (this.projectId?.id) {
      obj['project'] = this.projectId?.id.toString()
    }
    if (this.displayData == 'completed') {
      obj['status'] = '3'
    } else if (this.displayData == 'pending') {
      obj['status'] = '2'
    };
    obj['is_event_ops'] = true;
    // obj['filter_pending'] = true;
    // event
    // obj['event'] = this.eventId ? this.eventId.toString() : '';
    return obj
  }

  getData() {
    // Only fetch tasks if event has a project assigned
    if (!this.projectId || !this.projectId.id) {
      this.loading = false;
      this.taskList = [];
      return;
    }

    this.loading = true
    this.vm.getPriorityList(1, 100);
    this.vm.getTaskStatusList(1, 100);
    let obj = this.getBasicFilterObject();
    this.vm.getTaskList(1, 100, '', obj)
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  onChange(e: any, type: string) {

    switch (type) {
      case 'due_date':
        let date = this.datepipe.transform(new Date(e), 'yyyy-MM-dd')
        this.taskFilter[type] = date
        break;
      case 'assigned_to':
        this.taskFilter[type] = e
        break;
      case 'assigned_to_group':
        this.taskFilter[type] = e
        break;
      case 'task_status':
        this.taskFilter[type] = e
        break;
      case 'priority':
        this.taskFilter[type] = e
        break;
      default:
        this.taskFilter[type] = undefined
    }

    this.getData()

  }

  onSearch() {
    this.searchText$.next(this.searchText)
  }

  addTask() {
    this.quickAddService.openQuickAdd('task')
  }


  goToTaskDetailModal(data: any) {
    this.showTaskDetail = false;
    this.selectData = data
    this.selectedType = 'task'
    this.showTaskDetail = true;
  }

  closeTaskDetail() {
    this.showTaskDetail = false;
  }

  projectTaskRecieved() {
    // this.taskList = this.taskDataList.value.results;

    if(this.taskDataList.value.results != null || this.taskDataList.value.results != undefined){
      this.taskList = this.taskDataList.value.results;
    } else {
      this.taskList = [];
      console.log("No task data received",this.taskList);
    }

    this.loading = false
  }

  taskPriorityName(id: number) {
    return id ? this.listOfPriority?.filter(e => e.id == id)[0]?.name : ''
  }

  getTaskStatusName(id: number): string {
    return id ? this.listOfTaskStatus?.filter(e => e.id == id)[0]?.name : '';

  }

  formatIdToFourDigits(id: number): string {
    return id ? 'TS' + id.toString().padStart(4, '0') : '';
  }

  getBase64Image(data: string) {
    if (!data) {
      return undefined;
    }
    return "data:image/png;base64," + data;
  }

  get hasActiveFilter(): boolean {
    return !!(
      this.searchText?.trim() ||
      this.taskFilter.assigned_to ||
      this.taskFilter.assigned_to_group ||
      this.taskFilter.task_status ||
      this.taskFilter.priority ||
      this.taskFilter.due_date
    );
  }


  getStatusBadge(status: string): string {
    switch (status) {
      case 'Closed': return 'success';
      case 'In-Progress': return 'processing';
      case 'Open': return 'default';
      case 'Waiting Cost Approval': return 'warning';
      default: return 'default';
    }
  }
}
